// import { KeyboardistListener } from 'keyboardist';

type KeyboardistListener = {
  startListening: () => void;
  stopListening: () => void;
};
const DEACTIVATED = 'DEACTIVATED';

export class KeyboardModes {
  modes: { [index: string]: KeyboardistListener } = {};

  currentMode: string = null;
  kbDeactivated = false;

  addMode(key: string, mode: KeyboardistListener) {
    const oldMode: KeyboardistListener = this.modes[key];
    if (oldMode && oldMode !== mode) {
      oldMode.stopListening();
    }
    this.modes[key] = mode;
  }

  stopListening() {
    for (const mode0 of Object.values(this.modes)) {
      const mode: KeyboardistListener = mode0;
      mode.stopListening();
    }
  }

  adjustKbHandlingForMode() {
    this.stopListening();
    if (this.currentMode && !this.kbDeactivated) {
      const mode: KeyboardistListener = this.modes[this.currentMode];
      mode.startListening();
    }
  }

  setKbDeactivated(value: boolean) {
    this.kbDeactivated = value;
    this.adjustKbHandlingForMode();
  }

  setMode(key: string) {
    this.currentMode = key;
    this.adjustKbHandlingForMode();
  }
}
